module.exports = __webpack_public_path__ + "public/files/img/url.668bab7d.png";